import numeral from 'numeral';
import { colors } from '../../lib/colors';

const keys = (t) => [
    {
        key: 'name',
        label: t('discover.categories.bubbles.category'),
        color: colors[0],
        bubble: true,
        value: 'impressions',
    },
    {
        key: 'impressions',
        label: t('discover.categories.bubbles.impressions'),
        format: '0,00',
        color: colors[1],
    },
    {
        key: 'ctr',
        label: t('discover.categories.bubbles.ctr'),
        render: (data) => numeral(data * 100).format('0.00'),
        format: '0.00%',
        color: colors[2],
    },
];

export default keys;
